import { cn } from "@wags/ui/ui-utils";

export function IconSlot({
    className,
    children,
}: {
    className?: string;
    children: React.ReactNode;
}) {
    return (
        <span
            data-slot="icon-slot"
            className={cn(
                "inline-flex h-[21px] w-6 shrink-0 items-center justify-center",
                className,
            )}
        >
            {children}
        </span>
    );
}
